/**
 * JWT Payload Helpers
 * Shared utilities for extracting values from JWT token payloads.
 * Federate tokens use UPPERCASE keys (EMAIL, GIVEN_NAME, LDAP_GROUP, etc.).
 */

export function getPayloadValue(
  payload: Record<string, unknown>,
  key: string
): string {

  const val = payload[key.toUpperCase()] ?? payload[key.toLowerCase()];

  return val !== undefined && val !== null ? String(val) : "";
}

export function extractLdapGroups(
  payload: Record<string, unknown>
): string[] {

  const raw = getPayloadValue(payload, "custom:LDAP_GROUP") || getPayloadValue(payload, "LDAP_GROUP");

  if (!raw) return [];
  if (Array.isArray(raw)) return raw.map((g: string) => g.trim());
  return String(raw).split(",").map((g) => g.trim());
}
